import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Link } from '@sda/interfaces/link';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const startCreateLink = createAction<{ target: string, slug: string }>(`${Reducers.LINKS}/startCreateLink`);
export const startUpdateLink = createAction<{ target: string, slug: string }>(`${Reducers.LINKS}/startUpdateLink`);
export const startDeleteLink = createAction<string>(`${Reducers.LINKS}/startDeleteLink`);

export const linkAdapter = createEntityAdapter<Link & FetchDataType>();

const linksSlice = createSlice({
  initialState: linkAdapter.getInitialState(),
  name: Reducers.LINKS,
  reducers: {
    ...extractSharedActions(linkAdapter),
  },
});

export const {
  addOne: addLink, removeOne: removeLink, updateOne: updateLink, upsertMany: upsertLinks,
} = linksSlice.actions;

export default linksSlice.reducer;
